import { render, staticRenderFns } from "./murajaah.vue?vue&type=template&id=5e81802b&scoped=true&"
import script from "./murajaah.vue?vue&type=script&lang=js&"
export * from "./murajaah.vue?vue&type=script&lang=js&"
import style0 from "./murajaah.vue?vue&type=style&index=0&id=5e81802b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e81802b",
  null
  
)

export default component.exports